import axios from "axios";
import { Dispatch } from "redux";
import { tokenConfig } from "../utils/headers";
import { CustomerDispatchTypes, CUSTOMER_FAIL, CUSTOMER_LOADING, CUSTOMER_SUCCESS } from "./customerActionTypes";



export const fetchCustomers = ( ) => async ( dispatch: Dispatch< CustomerDispatchTypes > ) => {

    try {

        dispatch( { 

            type: CUSTOMER_LOADING

        } );
        console.log( tokenConfig )
        const tokenConfig1 = {
            // "x-auth-token": localStorage.getItem("token"),
            headers: {
                accept: "/*/",
                Authorization: "Bearer " + localStorage.getItem("shreeDevToken"),
            },
        };

        axios.get( 'https://shreee-development-test.herokuapp.com/admin/all-customers', tokenConfig1 )
        .then( ( res: any ) => { 

            console.log( 'res: ', res );
            dispatch( { 

                type: CUSTOMER_SUCCESS,
                payload: res.data.data

            } );

        } )
        .catch( ( e: any ) => { 

            console.log( 'in err: ', e );
            dispatch( { 

                type: CUSTOMER_FAIL,
                payload: e.response.data.msg

            } );
        } )
    
    }
    catch( e ) {

        console.log( 'in Catch ', e );
        dispatch( { 

            type: CUSTOMER_FAIL,
            payload: "Some unknown Error"

        } )
    }

};